export function ellipsis(value: string, length: number = 25, startingAmount: number = 10, endingAmount: number = 5): string {
    if (!value || value.length < length) {
        return value;
    }

    if (endingAmount !== 0) {
        return `${value.slice(0, startingAmount)}...${value.slice(-endingAmount)}`;
    }

    return `${value.slice(0, startingAmount)}...`;
}

export function uppercaseFirstLetter(value: string): string {
    if (!value) {
        return value;
    }

    return value.charAt(0).toUpperCase() + value.slice(1);
}